import React, { useContext, useEffect, useState } from "react";
import { Socket } from "socket.io-client";
import IVendorModel from "../../../../models/IVendorModel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwPickList from "../../../shared/OwPickList/OwPickList";
import IWarehouse from "../../../../models/IWarehouse";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IUpdateVendorWarehouseMapDTO from "../../../../models/DTO/IUpdateVendorWarehouseMapDTO";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import INotification from "../../../../models/INotification";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import IOnGetVendorWarehouseMapDTO from "../../../../models/DTO/IOnGetVendorWarehouseMapDTO";

type Props = {
    notifyFn: (data: any, notification: any) => void;
    socket: Socket;
    vendorModel: IVendorModel;
    availableWarehouses: IWarehouse[];
    closeFn: () => void;
};

export const EditWarehouseAccess = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [isLoading, setIsLoading] = useState(true);
    const [selectedWarehouses, setSelectedWarehouses] = useState<IWarehouse[]>([]);

    useEffect(() => {
        props.socket.on(EndpointsEnum.VendorOnUpdateVendorWarehouseMap, onUpdateVendorWarehouseMap);
        props.socket.on(EndpointsEnum.VendorOnGetVendorWarehouseMap, onGetVendorWarehouseMap);

        getVendorWarehouseMap();

        return () => {
            props.socket.removeListener(EndpointsEnum.VendorOnUpdateVendorWarehouseMap, onUpdateVendorWarehouseMap);
            props.socket.on(EndpointsEnum.VendorOnGetVendorWarehouseMap, onGetVendorWarehouseMap);
        };
    }, []);

    const getVendorWarehouseMap = () => {
        const payload = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: props.vendorModel.guid,
        };

        props.socket.emit(EndpointsEnum.VendorGetVendorWarehouseMap, payload);
    };

    const onGetVendorWarehouseMap = (data: IOnGetVendorWarehouseMapDTO) => {
        setIsLoading(false);
        setSelectedWarehouses(data.warehouses);
    };

    const updateVendorWarehouseMap = (selectedOptionsArr: any[]) => {
        // send to the server

        console.log("selectedOptionsArr", selectedOptionsArr);

        const warehouseMapItems = selectedOptionsArr.map((mapItem) => {
            return {
                warehouse_id: Number(mapItem.value),
                vendor_id: props.vendorModel.id,
                isDefault: false,
            };
        });

        const payload: IUpdateVendorWarehouseMapDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: props.vendorModel.guid,
            mapItems: warehouseMapItems,
        };

        props.socket.emit(EndpointsEnum.VendorUpdateVendorWarehouseMap, payload);
    };

    const onUpdateVendorWarehouseMap = () => {
        const notification: INotification = {
            message: "successfully_updated_warehouse_access",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        props.notifyFn(null, notification);

        props.closeFn();
    };

    return (
        <div className={"EditWarehouseAccess p-2"}>
            <OwTitle title={"edit_warehouse_access"} tag={"h2"} />
            {isLoading ? (
                <div>
                    <OwLabel title={"loading_data"} />
                </div>
            ) : (
                <OwPickList
                    availableOptions={props.availableWarehouses}
                    titleProp={"name"}
                    valueProp={"id"}
                    selectedOptions={selectedWarehouses}
                    saveFn={updateVendorWarehouseMap}
                />
            )}
        </div>
    );
};
